<script setup>
// Astra DS · ChipPodcast — `Chip Variant=podcast` (`2718:4`), el chip PODCAST.
//
// Entrega `docs/entregas/2026-11-01-radio-podcast-en-lo-que-sigue.md`,
// decidido por Pablo el 01.11.26. Mismo molde que el NUEVO pequeño
// (`ChipNuevo`); va detrás del artista en la fila del podcast de Lo que sigue,
// a 10 y centrado con él. **Solo ahí**: el salvia en cualquier otra pieza está
// mal (DESIGN.md § Radio · el podcast se agrupa en Lo que sigue).
//
//   18 de alto · 6 a los lados · 5 entre piezas · sin radio
//   `color/podcast/bg` de fondo · `Icon/mic` a 12 y «PODCAST» en `mono/nano`,
//   los dos en `color/podcast/text`
import AstraIcon from "@/components/icons/AstraIcon.vue";
</script>

<template>
  <span class="chip-podcast">
    <AstraIcon name="mic" :size="12" />
    <span>Podcast</span>
  </span>
</template>

<style scoped lang="scss">
@use "@/assets/scss/type" as t;

.chip-podcast {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 5px;
  box-sizing: border-box;
  height: 18px;
  padding: 0 6px;
  background: var(--color-podcast-bg);
  color: var(--color-podcast-text);

  span {
    @include t.mono-nano;
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
